/* @ngInject */
const myTrainEditForm = (

) => {
  return {
    restrict: 'E',
    scope: {
      myTrain: '=',
    },
    template: require('./myTrainEditForm.html'),
    /* @ngInject */
    controller: (
      $scope,
      $$train
    ) => {
      $scope.updateTrain = (_train) => {
        $$train.ask.update(_train, true)
      }
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myTrainEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/directives/forms/myTrainEditForm.js